__turbopack_context__.v({
  "active": "tabs-module-scss-module__sZJeZW__active",
  "jetCatalogButton": "tabs-module-scss-module__sZJeZW__jetCatalogButton",
  "jetCatalogButtons": "tabs-module-scss-module__sZJeZW__jetCatalogButtons",
  "swiper": "tabs-module-scss-module__sZJeZW__swiper",
  "swiperSlide": "tabs-module-scss-module__sZJeZW__swiperSlide",
});
